import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { EmailCheckMark } from '../Icons/EmailCheckMark';

const FormSent = () => (
    <div className="contact-form-container">
        <div className="contact-form-sent">
            <EmailCheckMark width={43} height={32} viewBox="0 0 43 32" />
            <h3>{__('THANK YOU!', 'dreamlines')}</h3>
            <p>{__('One of our cruise advisors will contact you soon.', 'dreamlines')}</p>
        </div>
    </div>
);

export default FormSent;
